import { LinkButton, ModalWindow, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './MortgageProgramModal.css';
import { mortgageLogo } from '../../assets';
import { ProgramContent } from './components';
import { IMortgageProgramModal } from './types';
import { MORTGAGE_LINK } from '../../../../constants/mortgage';

export const MortgageProgramModal: React.FC<IMortgageProgramModal> = ({
  name,
  onClose,
  onMortgageButtonClick,
  ...selectedProgram
}) => {
  return (
    <ModalWindow
      open
      onClose={onClose}
      size="M"
      width={693}
      content={
        <div className={styles['inner']}>
          <div className={styles['title']}>
            <UIHeading2>Программа ипотеки «{name}»</UIHeading2>
          </div>
          <div className={styles['content']}>
            <ProgramContent {...selectedProgram} />
          </div>
          <div className={styles['footer']}>
            <img src={mortgageLogo} />
            <LinkButton
              size="M"
              theme="fill_primary"
              href={MORTGAGE_LINK}
              target="_blank"
              onClick={() => onMortgageButtonClick(selectedProgram.id)}
            >
              Подать заявку онлайн
            </LinkButton>
          </div>
        </div>
      }
    />
  );
};
